var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('BaseBreadcrumb',{attrs:{"title":_vm.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.TITLE'),"breadcrumbs":[
      {
        text: _vm.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.ALL_DISPUTES'),
        disabled: true
      }
    ]}}),_c('v-card',[_c('v-card-text',[_c('v-data-table',{attrs:{"headers":[
          {
            text: '#',
            align: 'start',
            sortable: false,
            value: 'ID'
          },
          {
            text: _vm.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.CREATED_AT'),
            align: 'start',
            sortable: false,
            value: 'CreatedAt'
          },
          {
            text: _vm.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.SERVICE_TIME'),
            align: 'start',
            sortable: false,
            value: 'ServiceTime'
          },
          {
            text: _vm.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.PLACE_NAME'),
            align: 'start',
            sortable: false,
            value: 'PlaceName'
          },
          {
            text: _vm.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.SERVICE_NAME'),
            align: 'start',
            sortable: false,
            value: 'ServiceName'
          },
          {
            text: _vm.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.AMOUNT'),
            align: 'start',
            sortable: false,
            value: 'Amount'
          },
          {
            text: _vm.$vuetify.lang.t('$vuetify.CLIENT_ID'),
            align: 'start',
            sortable: false,
            value: 'ClientId'
          },
          {
            text: _vm.$vuetify.lang.t('$vuetify.EMAIL'),
            align: 'start',
            sortable: false,
            value: 'Email'
          },
          {
            text: _vm.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.LICENSE_PLATE'),
            align: 'start',
            sortable: false,
            value: 'LicensePlate'
          },
          {
            text: _vm.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.MESSAGE'),
            align: 'start',
            sortable: false,
            value: 'Message'
          },
          {
            text: _vm.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.STATUS'),
            align: 'start',
            sortable: false,
            value: 'Status'
          },
          {
            text: '',
            align: 'end',
            sortable: false,
            value: 'actions'
          }
        ],"items":_vm.disputes,"hide-default-footer":"","items-per-page":_vm.pageSize},scopedSlots:_vm._u([{key:"item.CreatedAt",fn:function(props){return [_c('td',[_vm._v(_vm._s(_vm.dateEE(props.item.CreatedAt)))])]}},{key:"item.ServiceTime",fn:function(props){return [_c('td',[_vm._v(_vm._s(_vm.dateEE(props.item.ServiceTime) || '-'))])]}},{key:"item.Amount",fn:function(props){return [_c('td',[_vm._v(" "+_vm._s(props.item.AmountInCents / 100 || '-')+" "+_vm._s(props.item.Currency)+" ")])]}},{key:"item.ClientId",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.ClientId || '-'))])]}},{key:"item.Email",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.Email || '-'))])]}},{key:"item.Message",fn:function(props){return [_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.onMessageClick(props.item)}}},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
        var on = ref.on;
return [_c('div',_vm._g({staticClass:"text-truncate",staticStyle:{"max-width":"124px"}},on),[_vm._v(" "+_vm._s(props.item.Message || '-')+" ")])]}}],null,true)},[_c('span',[_c('div',{staticClass:"text-truncate",staticStyle:{"max-width":"624px"}},[_vm._v(" "+_vm._s(props.item.Message || '-')+" ")])])])],1)]}},{key:"item.actions",fn:function(props){return [_c('td',{staticClass:"d-flex align-center"},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
        var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"secondary--text",attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.onEditDisputeClick(props.item)}}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-pencil")])],1)]}}],null,true)},[_c('span',[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.EDIT_DISPUTE'))+" ")])]),(
                props.item.Status !== 'REJECTED' &&
                  props.item.Status !== 'APPROVED'
              )?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"error--text",attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.onDisputeRejectClick(props.item)}}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-cancel")])],1)]}}],null,true)},[_c('span',[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.REJECT'))+" ")])]):_vm._e(),(
                props.item.Status !== 'REJECTED' &&
                  props.item.Status !== 'APPROVED'
              )?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"success--text",attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.onDisputeApproveClick(props.item)}}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-check")])],1)]}}],null,true)},[_c('span',[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.APPROVE'))+" ")])]):_vm._e()],1)]}},{key:"item.Status",fn:function(props){return [_c('td',[_c('span',{staticClass:"white--text font-weight-bold caption",staticStyle:{"border-radius":"20px","padding":"4px 6px"},style:({
                'background-color': _vm.disputeStatusColor(props.item.Status)
              }),attrs:{"left":""}},[_vm._v(" "+_vm._s(props.item.Status)+" ")])])]}}])}),_c('v-toolbar',{staticClass:"elevation-0",attrs:{"color":"transparent"}},[_c('v-spacer'),_c('v-btn',{staticClass:"ma-2",attrs:{"fab":"","color":"white","x-small":"","disabled":_vm.currentPageNumber === 0},on:{"click":function($event){return _vm.prevPage()}}},[_c('v-icon',{attrs:{"color":"rgba(0, 0, 0, 0.54)"}},[_vm._v("mdi-menu-left")])],1),_c('v-btn',{staticClass:"secondary--text",attrs:{"fab":"","color":"primary","x-small":"","readonly":""}},[_vm._v(" "+_vm._s(_vm.currentPageNumber + 1)+" ")]),_c('v-btn',{staticClass:"ma-2",attrs:{"fab":"","color":"white","x-small":"","disabled":!_vm.nextAvailablePage || _vm.nextAvailablePage <= 0},on:{"click":function($event){return _vm.nextPage()}}},[_c('v-icon',{attrs:{"color":"rgba(0, 0, 0, 0.54)"}},[_vm._v("mdi-menu-right")])],1),_c('v-spacer'),_c('v-col',{staticClass:"pa-0",attrs:{"cols":"1"}},[_c('v-select',{attrs:{"items":[10, 30, 50, 100],"label":_vm.$vuetify.lang.t('$vuetify.STATISTICS.SHOW'),"hide-details":""},on:{"change":_vm.onPageSizeChange},model:{value:(_vm.pageSize),callback:function ($$v) {_vm.pageSize=$$v},expression:"pageSize"}})],1)],1)],1)],1),_c('edit-dispute-dialog',{attrs:{"visible":_vm.disputeEditDialog},on:{"close":function($event){_vm.disputeEditDialog = false}}}),(_vm.selectedDispute)?_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.disputeMessageDialog),callback:function ($$v) {_vm.disputeMessageDialog=$$v},expression:"disputeMessageDialog"}},[_c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.CAR_WASH_DISPUTES.MESSAGE'))+" ")]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.selectedDispute.Message)+" ")]),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.disputeMessageDialog = false}}},[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.CLOSE'))+" ")])],1)],1)],1):_vm._e(),_c('RejectDisputeDialog',{attrs:{"visible":_vm.showDisputeRejectDialog},on:{"close":function () {
        _vm.showDisputeRejectDialog = false
      }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }